import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CultivationPage from './pages/CultivationPage';
import ArtifactRefiningPage from './pages/ArtifactRefiningPage';
import DivinationPage from './pages/DivinationPage';
import TelomereTestingPage from './pages/TelomereTestingPage';
import VirtualCurrencyPage from './pages/VirtualCurrencyPage';
import DiscipleProfilePage from './pages/DiscipleProfilePage';
import QuestSystemPage from './pages/QuestSystemPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import UserDashboardPage from './pages/UserDashboardPage';
import ARViewPage from './pages/ARViewPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cultivation" element={<CultivationPage />} />
          <Route path="/artifact-refining" element={<ArtifactRefiningPage />} />
          <Route path="/divination" element={<DivinationPage />} />
          <Route path="/telomere-testing" element={<TelomereTestingPage />} />
          <Route path="/virtual-currency" element={<VirtualCurrencyPage />} />
          <Route path="/disciple-profile" element={<DiscipleProfilePage />} />
          <Route path="/quest-system" element={<QuestSystemPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<UserDashboardPage />} />
          <Route path="/ar-view" element={<ARViewPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
